import { useState } from "react";

// Extracts the real error message from a supabase.functions.invoke() result.
// When the Edge Function returns non-2xx, supabase-js puts a generic string in
// error.message and the actual JSON body in error.context (a Response object).
const fnErrMsg = async (error, data) => {
  if (data?.error) return data.error;
  if (!error) return null;
  try {
    const body = await error.context?.json?.();
    if (body?.error) return body.error;
  } catch {}
  return error.message;
};

export function useTeamData(supabase, landlordId, reload) {
  const [teamMembers, setTeamMembers] = useState([]);
  const [showAddMember, setShowAddMember] = useState(false);
  const [newMember, setNewMember] = useState({ email: "", name: "", role: "view_only" });

  const addTeamMember = async () => {
    if (!newMember.email) return;
    const { data, error } = await supabase.functions.invoke("invite-team-member", {
      body: { action: "invite", email: newMember.email.toLowerCase().trim(), role: newMember.role, landlordId },
    });
    const errMsg = await fnErrMsg(error, data);
    if (errMsg) { alert("Error sending invite: " + errMsg); return; }
    setNewMember({ email: "", name: "", role: "manager" });
    setShowAddMember(false);
    reload();
  };

  const resendInvite = async (member) => {
    const { data, error } = await supabase.functions.invoke("invite-team-member", {
      body: { action: "invite", email: member.email, role: member.role, landlordId },
    });
    const errMsg = await fnErrMsg(error, data);
    if (errMsg) { alert("Error resending invite: " + errMsg); return; }
    alert(`Invite resent to ${member.email}`);
  };

  const removeTeamMember = async (id, isPending = false) => {
    const confirmMsg = isPending
      ? "Revoke this invite? The invite link will be invalidated."
      : "Remove this team member? They will lose dashboard access.";
    if (!window.confirm(confirmMsg)) return;
    if (isPending) {
      const { data, error } = await supabase.functions.invoke("invite-team-member", {
        body: { action: "revoke", memberId: id },
      });
      const errMsg = await fnErrMsg(error, data);
      if (errMsg) { alert("Error revoking invite: " + errMsg); return; }
    } else {
      await supabase.from("team_members").delete().eq("id", id);
    }
    reload();
  };

  const updateMemberRole = async (id, role) => {
    await supabase.from("team_members").update({ role }).eq("id", id);
    reload();
  };

  return {
    teamMembers, setTeamMembers,
    showAddMember, setShowAddMember,
    newMember, setNewMember,
    addTeamMember, resendInvite, removeTeamMember, updateMemberRole,
  };
}
